(function() {
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('return_to');

  if (returnTo) {
    sessionStorage.setItem('return_to_after_auth', returnTo);
  }

  const saved = sessionStorage.getItem('return_to_after_auth');
  if (!saved) return;

  const forms = document.querySelectorAll('form[action="/account/login"], form[action="/account"]');
  if (!forms) return;

  forms.forEach(function (form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    input.value = saved;
    form.appendChild(input);
  });
})();